module.exports = __webpack_public_path__ + "img/acount.49f6ae69.jpg";